import { SwitchComponent } from '@syncfusion/ej2-react-buttons';
import {
  DatePickerComponent,
  TimePickerComponent,
} from '@syncfusion/ej2-react-calendars';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { GridComponent, RowSelectEventArgs } from '@syncfusion/ej2-react-grids';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import {
  ButtonPropsModel,
  DialogComponent,
} from '@syncfusion/ej2-react-popups';
import moment from 'moment';
import React, { useContext, useEffect, useState } from 'react';
import {all_information, GetErpTypeFromConfig, loadingShow} from '../../App';
import DigServices from '../../services/Dig/DigServices';
import Message from '../../utils/Message/Message';
import './style.css';
import { BiRefresh } from 'react-icons/bi';
import { RiTaskFill } from 'react-icons/ri';
import { ThemeContext } from '../../context/theme.context';
import {
  AddContainer,
  AddContainerTask,
  DeleteContainer,
  DeleteContainerTask,
  EditContainer,
} from '../../services/Dig/SyncContainer/SyncContainerServices';
import GlobalDialog from '../../components/GlobalDialog';
import GlobalGrid from '../../components/GlobalGrid';

interface IProps {}
let grid: any;
let gridTaskWitContainer: any;
let digServices = new DigServices();
let dialog: DialogComponent = new DialogComponent({});
let buttons: ButtonPropsModel[];
let container_name = '';
let enabled_date: any = '';
let alert_mail = '';
let last_run: any = undefined;
let next_run: any = undefined;
let start_date: any = undefined;
let status: boolean = false;
let enabled: boolean = false;
let start_time: Date;
let adapter_name: string = '';
let isAdd: boolean = true;
let container_id: number = -1;
let selectedDays: any = '';
let selectedDate: Date;
let selectedDateValue: Date = new Date();
let log_message = '';

let isDone: boolean = false;
let isCancelRequest: boolean = false;
let isRun: boolean = false;
let theTheDays = [
  { name: 'Sunday', id: 0 },
  { name: 'Monday', id: 1 },
  { name: 'Tuesday', id: 2 },
  { name: 'Wednesday', id: 3 },
  { name: 'Thursday', id: 4 },
  { name: 'Friday', id: 5 },
  { name: 'Saturday', id: 6 },
];
let selectedDaysValue: number = -1;
let interval_name: string = '';
let hourly_minute_value: number = 5;
let per_minute_value: number = 5;

const SyncContainer: React.FC<IProps> = () => {
  const [hideDialgogisAdd, setHideDialgogisAdd] = useState<boolean>(false);
  const [hideAddEditDialog, setHideAddEditDialog] = useState(false);
  const [adapterValue, setAdapterValue] = useState('');
  const [adapterData, setAdapterData] = useState([]);
  const [intervalData, setIntervalData] = useState([
    { name: 'Once', id: 1 },
    { name: 'Daily', id: 2 },
    { name: 'Weekly', id: 3 },
    { name: 'Hourly', id: 4 },
    { name: 'Per Minute', id: 5 },
  ]);
  const [intervalValue, setIntervalValue] = useState('');
  const [isOnce, setIsOnce] = useState(false);
  const [isWeekly, setIsWeekly] = useState(false);
  const [isDaily, setIsDaily] = useState<boolean | undefined>(undefined);
  const [isHourly, setIsHourly] = useState(false);
  const [isPerMin, setIsPerMin] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [showDialog, setShowDialog] = useState(false);
  const [c_container_id, setCContainerId] = useState(-1);
  const [refresh_token, setRefreshToken] = useState(-1);
  const [refreshGrid, setRefreshGrid] = useState<string>('');
  const context = useContext(ThemeContext);
  var IsContainerTaskClickedIndexList: number[] = [];
  const toolbarOptions: any = [
    {
      text: 'Add',
      tooltipText: 'Add',
      prefixIcon: 'e-add',
      id: 'add',
    },
    {
      text: 'Edit',
      tooltipText: 'Edit',
      prefixIcon: 'e-edit',
      id: 'edit',
    },
    {
      text: 'Delete',
      tooltipText: 'Delete',
      prefixIcon: 'e-delete',
      id: 'delete',
    },
    {
      text: 'Tasks',
      tooltipText: 'Tasks',
      id: 'cont-task',
    },
    'Search',
    // {
    //   text: 'Run',
    //   tooltipText: 'Run',
    //   prefixIcon: ' e-list-touch',
    //   id: 'run',
    // },
    {
      text: 'Refresh',
      tooltipText: 'refresh',
      prefixIcon: ' e-refresh',
      id: 'refresh',
    },
  ];
  buttons = buttons = [
    {
      click: () => {
        saveAndEditContainer();
      },
      buttonModel: {
        content: 'Save',
        isPrimary: true,
      },
    },
    {
      click: () => {
        setHideAddEditDialog(false);
      },
      buttonModel: {
        content: 'Cancel',
      },
    },
  ];
  const enabledTemplate = (e: any) => {
    return (
      <div>
        {e.enabled ? (
          <div
            style={{
              backgroundColor: '#339933',
              width: '100%',
              height: 25,
              borderRadius: 5,
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex',
              color: 'white',
            }}
          >
            ACTIVE
          </div>
        ) : (
          <div
            style={{
              backgroundColor: '#C90016',
              width: '100%',
              height: 25,
              borderRadius: 5,
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex',
              color: 'white',
            }}
          >
            INACTIVE
          </div>
        )}
      </div>
    );
  };
  const statusTemplate = (e: any) => {
    let current_content;
    if (e.status === 0) {
      current_content = (
        <div
          style={{
            backgroundColor: '#339933',
            width: '100%',
            height: 25,
            borderRadius: 5,
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
            color: 'white',
          }}
        >
          SUCCESS
        </div>
      );
    } else if (e.status === 1) {
      current_content = (
        <div
          style={{
            backgroundColor: '#C90016',
            width: '100%',
            height: 25,
            borderRadius: 5,
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
            color: 'white',
          }}
        >
          ERROR
        </div>
      );
    } else if (e.status === 2) {
      current_content = (
        <div
          style={{
            backgroundColor: '#339933',
            width: '100%',
            height: 25,
            borderRadius: 5,
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
            color: 'white',
          }}
        >
          RUNNING
        </div>
      );
    } else if (e.status === 3) {
      current_content = (
        <div
          style={{
            backgroundColor: '#fcba03',
            width: '100%',
            height: 25,
            borderRadius: 5,
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
            color: 'white',
          }}
        >
          PENDING
        </div>
      );
    }
    return <div>{current_content}</div>;
  };
  const tasksColumns = [
    {
      field: 'isChecked',
      headerText: '#',
      width: '70',
      type: 'checkbox',
    },
    {
      // template={(args: any) => {
      //   return (
      //     <div>
      //       <AiFillRightCircle
      //         size={20}
      //         onClick={this.gotoTask.bind(this, args)}
      //       />
      //     </div>
      //   );
      // }}
      field: '',
      headerText: 'Details',
    },
    {
      field: 'task_id',
      headerText: 'Task ID',
      textAlign: 'Left',
    },
    {
      field: 'task_name',
      headerText: 'Task Name',
      textAlign: 'Left',
    },
    {
      field: 'adapter_name',
      headerText: 'Adapter',
      textAlign: 'Left',
    },
    {
      field: 'companyName',
      headerText: 'Company Name',
      textAlign: 'Left',
    },
    {
      field: 'target_table',
      headerText: 'Target Table',
      textAlign: 'Left',
    },
    {
      field: 'seq',
      headerText: 'Seq',
      textAlign: 'Left',
    },
    {
      field: 'enabled',
      headerText: 'Enabled',
      template: enabledTemplate,
      textAlign: 'Left',
      width: '70px',
    },
  ];
  const containerColumns = [
    {
      field: 'container_id',
      headerText: 'Container ID',
      textAlign: 'Left',
      isPrimaryKey: true,
      allowEditing: false,
      visible: false,
    },
    {
      field: 'container_name',
      headerText: 'Container Name',
      textAlign: 'Left',
    },
    {
      field: 'companyName',
      headerText: 'Company Name',
      textAlign: 'Left',
    },
    {
      field: 'adapter_name',
      headerText: 'Adapter',
      textAlign: 'Left',
    },
    {
      field: 'start_date',
      headerText: 'Start Date',
      textAlign: 'Left',
      format: 'dd/MM/yyyy HH:mm',
      type: 'date',
    },
    {
      field: 'next_run',
      headerText: 'Next Run',
      textAlign: 'Left',
      format: 'dd/MM/yyyy HH:mm',
      type: 'date',
    },
    {
      field: 'last_run',
      headerText: 'Last Run',
      textAlign: 'Left',
      format: 'dd/MM/yyyy HH:mm',
      type: 'date',
    },
    {
      field: 'enabled_date',
      headerText: 'Enabled Date',
      textAlign: 'Left',
      format: 'dd/MM/yyyy HH:mm',
      type: 'date',
    },
    {
      field: 'alert_mail',
      headerText: 'Alert Mail',
      textAlign: 'Left',
    },
    {
      field: 'interval',
      headerText: 'Interval',
      textAlign: 'Left',
    },

    {
      field: 'status',
      headerText: 'Status',
      template: statusTemplate,
      textAlign: 'Left',
      width: '70px',
    },
    {
      field: 'enabled',
      headerText: 'Enabled',
      template: enabledTemplate,
      textAlign: 'Left',
      width: '70px',
    },
  ];
  const toolbarClick = async (args: any) => {
    if (args.item.id === 'add') {
      status = false;
      enabled = false;
      isAdd = true;
      container_name = '';
      start_time = new Date();
      setAdapterValue('');
      setHideDialgogisAdd(true);
      setHideAddEditDialog(true);
    }
    if (args.item.id === 'cont-task') {
      if (grid.getSelectedRecords()) {
        if (grid.getSelectedRecords().length > 0) {
          setShowDialog(true);
        }
      }
    }
    if (args.item.id === 'edit') {
      if (grid.getSelectedRecords()) {
        if (grid.getSelectedRecords().length > 0) {
          isAdd = false;
          var selectedElement = grid.getSelectedRecords() as any;
          container_name = selectedElement[0].container_name;
          container_id = selectedElement[0].container_id;
          adapter_name = selectedElement[0].adapter_name;
          alert_mail = selectedElement[0].alert_mail;
          log_message = selectedElement[0].log_message;
          last_run = selectedElement[0].last_run;
          let theInterval: any = intervalData.filter((el: any) => {
            return el.name === selectedElement[0].interval;
          });
          start_date = selectedElement[0].start_date;
          next_run = selectedElement[0].next_run;
          isRun = selectedElement[0].isRun;
          isDone = selectedElement[0].isDone;
          isCancelRequest = selectedElement[0].isCancelRequest;
          start_time = new Date(
            moment(selectedElement[0].start_date).format('yyyy-MM-DD HH:mm:ss')
          );
          status = selectedElement[0].status;
          enabled = selectedElement[0].enabled;
          let theDaily = theInterval[0].id === 2 ? true : false;
          let theHourly = theInterval[0].id === 4 ? true : false;
          let thePerMin = theInterval[0].id === 5 ? true : false;
          if (theInterval[0].name === 'Hourly') {
            hourly_minute_value = 2;
          }
          if(thePerMin){
            per_minute_value = Number(grid.getSelectedRecords()[0].interval_time) / (60000)
          }
          selectedDaysValue = start_time.getDay();
          setHideDialgogisAdd(false);
          setHideAddEditDialog(true);
          setIntervalValue(theInterval[0]?.id);
          setAdapterValue(selectedElement[0].adapter_id);
          setIsDaily(theDaily);
          setIsHourly(theHourly);
          setIsPerMin(thePerMin);
        }
      }
    }
    if (args.item.id === 'run') {
      if (grid?.getSelectedRecords()) {
        if (grid.getSelectedRecords().length > 0) {
          var selectedElement = grid.getSelectedRecords() as any;
          let theObject = {
            ...selectedElement[0],
            // log_message:selectedElement[0].log_message===null?'':selectedElement[0].log_message,
            // next_run:selectedElement[0].next_run===null?'':selectedElement[0].next_run,
            isRun: true,
          };

          EditContainer(theObject)
            .then((el) => {
              var theData = el.data.Messages[0];
              if (theData === 'Success') {
                loadingShow(false);

                Message.success('Success');
              } else {
                Message.error(theData);
              }
            })
            .catch((e) => {
              Message.error('Error: ');
              //(e);
            });
        }
      }
    }
    if (args.item.id === 'delete') {
      await DeleteContainer({ ContainerID: c_container_id })
        .then((res) => {
          setRefreshGrid('refresh');
          Message.success('Success');
        })
        .catch((e) => {
          console.log('erroe', e);
        });
    }
    if (args.item.id === 'refresh') {
      setRefreshGrid('refresh');
    }
  };

  const saveAndEditContainer = () => {
    loadingShow(true, 'Progresing');
    if (container_name === '') {
      Message.error('Container name cannot be empty');
      loadingShow(false);
      return;
    }
    if (adapterValue === '') {
      loadingShow(false);
      Message.error('Adapter cannot be empty');
      return;
    }
    if (intervalValue === '') {
      loadingShow(false);
      Message.error('Interval cannot be empty');
      return;
    }
    if (
      selectedDateValue &&
      !isDaily &&
      !isHourly &&
      !isPerMin &&
      !isWeekly &&
      !isOnce
    ) {
      loadingShow(false);
      Message.error('Interval start date cannot be empty');
      return;
    }
    if (selectedDaysValue === -1 && isDaily && !isHourly && !isPerMin) {
      loadingShow(false);
      Message.error('Interval start day cannot be empty');
      return;
    }
    let interval_element = $('#tmSyncElement').val() as string;
    let startTime = $('#tmsyncElementStartTime').val() as string;
    let theStartTime = startTime.split(':');
    let startDayDate;
    let nextDate;
    let now = new Date();
    let interval_time = 0;
    let tick_time = 0;
    if (Number(intervalValue) === 1) {
      interval_time = 0;
      startDayDate = moment(selectedDateValue)
        .add(Number(theStartTime[0]), 'h')
        .add(Number(theStartTime[1]), 'm');
      if (startDayDate.toDate().getTime() < now.getTime()) {
        loadingShow(false);
        Message.error('Start date cannot be past');
        return;
      }
      tick_time = moment(startDayDate).diff(now);
      nextDate = null;
    } else if (Number(intervalValue) === 2) {
      let now = new Date().getDay();
      if (now <= selectedDaysValue) {
        startDayDate = moment().day(selectedDaysValue);
        nextDate = moment().day(selectedDaysValue + 1);
        startDayDate
          .add(Number(theStartTime[0]), 'h')
          .add(Number(theStartTime[1]), 'm');
        nextDate
          .add(Number(theStartTime[0]), 'h')
          .add(Number(theStartTime[1]), 'm');
        interval_time = 86400000;
        tick_time = moment(startDayDate).diff(moment());
      } else {
        startDayDate = moment().day(selectedDaysValue + 7);
        nextDate = moment().day(selectedDaysValue + 7 + 1);
        startDayDate
          .add(Number(theStartTime[0]), 'h')
          .add(Number(theStartTime[1]), 'm');
        nextDate
          .add(Number(theStartTime[0]), 'h')
          .add(Number(theStartTime[1]), 'm');
        interval_time = 86400000;
        tick_time = moment(startDayDate).diff(moment());
      }
    } else if (Number(intervalValue) === 3) {
      startDayDate = moment(selectedDateValue);
      nextDate = moment().day(startDayDate.day() + 7);
      startDayDate
        .add(Number(theStartTime[0]), 'h')
        .add(Number(theStartTime[1]), 'm');
      nextDate
        .add(Number(theStartTime[0]), 'h')
        .add(Number(theStartTime[1]), 'm');
      if (startDayDate.toDate().getTime() < now.getTime()) {
        loadingShow(false);
        Message.error('Start date cannot be past');
        return;
      }
      interval_time = 7 * 86400000;
      tick_time = moment(nextDate.toDate()).diff(startDayDate);
    } else if (Number(intervalValue) === 4) {
      startDayDate = moment(moment(new Date()).format('yyyy/MM/DD'))
        .add(Number(theStartTime[0]), 'h')
        .add(Number(theStartTime[1]), 'm');

      if (startDayDate.toDate().getTime() < now.getTime()) {
        startDayDate.add(24, 'h');
      }
      tick_time = moment(startDayDate).diff(now);
      interval_time = 3600000;
      nextDate = moment(startDayDate).add(Number(hourly_minute_value), 'm');
    } else if (Number(intervalValue) === 5) {
      startDayDate = moment(moment(new Date()).format('yyyy/MM/DD'))
        .add(Number(theStartTime[0]), 'h')
        .add(Number(theStartTime[1]), 'm');
      if (startDayDate.toDate().getTime() < now.getTime()) {
        startDayDate.add(24, 'h');
      }
      tick_time = moment(startDayDate).diff(now);
      interval_time = Number(per_minute_value) * 60000;
      nextDate = moment(startDayDate).add(Number(per_minute_value), 'm');
    }
    if (enabled) {
      enabled_date = moment(new Date());
    } else {
      enabled_date = null;
    }
    var tz = moment(new Date()).utcOffset();
    var result = tz - -240;
    result = result / 60;
    let theObject: any = {
      container_name: container_name,
      adapter_name: adapter_name,
      adapter_id: adapterValue,
      alert_mail: alert_mail,
      enabled: enabled,
      start_date: startDayDate?.toDate(),
      next_run: nextDate?.toDate(),
      interval: interval_element,
      enabled_date: enabled_date?.toDate(),
      last_run: last_run,
      container_id: container_id,
      gmt: result,
      log_message: log_message,
      isRun: isRun,
      status: 3,
      organization_id: all_information.company_id?.toString(),
      user_id: all_information.user_id,
      isDone: isDone,
      isCancelRequest: isCancelRequest,
      tick_time,
      interval_time,
      isClientSideEffect: true,
    };
    if (isAdd) {
      delete theObject.container_id;
      theObject.erp_type_name = GetErpTypeFromConfig();
      AddContainer(theObject)
        .then((el) => {
          loadingShow(false);
          Message.success('Success');
          setHideAddEditDialog(false);
          setRefreshToken(Math.random());
        })
        .catch((e) => {
          loadingShow(false);
          Message.error('Error: ');
          //(e);
        });
    } else {
      EditContainer(theObject)
        .then((el) => {
          loadingShow(false);
          Message.success('Success');
          setHideAddEditDialog(false);
          setRefreshToken(Math.random());
        })
        .catch((e) => {
          loadingShow(false);
          Message.error('Error: ');
        });
    }
  };
  const getAdapter = () => {
    digServices
      .getSourceAdaptors({ org_id: all_information.company_id })
      .then((el) => {
        setAdapterData(el.data);
      })
      .catch((e) => {
        //(e);
      });
  };

  const rowselectContainer = (args: RowSelectEventArgs) => {
    let selRecord: any = args.data;
    adapter_name = selRecord.adapter_name;
    interval_name = selRecord.interval;
    container_id = selRecord.container_id;
    container_name = selRecord.container_name;
    start_date = selRecord.start_date;
    status = selRecord.status;
    log_message = selRecord.log_message;
    setCContainerId(selRecord.container_id);
  };
  const SaveListContainerTask = (data: any) => {
    loadingShow(true, 'Progresing');
    AddContainerTask(data)
      .then((el) => {
        Message.success('Success');
        loadingShow(false);
      })
      .catch((e) => {
        loadingShow(false);
        Message.error('Error: ');
        //(e);
      });
  };
  const DeleteContainerTasks = (data: any) => {
    loadingShow(true, 'Progresing');
    DeleteContainerTask(data)
      .then((el) => {
        loadingShow(false);
        Message.success('Success');
      })
      .catch((e) => {
        loadingShow(false);
        Message.error('Error: ');
        //(e);
      });
  };
  const renderToolbarTemplate = (args: any) => {
    return (
      <div className='renderToolbar'>
        <button
          className='btn btn-secondary'
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          onClick={refreshTask}
        >
          <BiRefresh size={17} />
          Refresh
        </button>
        {/*  <button
          className='btn btn-secondary'
          onClick={() => {
            context.setChangeCurrentTabTask(true);
          }}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <RiTaskFill />
          Goto Tasks
        </button>*/}
        {/* <button className='btn btn-secondary'>View Container</button> */}
      </div>
    );
  };
  const refreshTask = () => {
    // (this.grid as GridComponent).refresh();
    // (this.gridTaskWitContainer as GridComponent).refresh();
  };
  const rowDeSelectContainer = (args: any) => {
    setIsDisabled(true);
  };
  const gotoTask = (args: any) => {
    context.setChangeCurrentTabTask(true, args.task_id);
  };
  useEffect(() => {
    getAdapter();
    return () => {};
  }, []);

  const isListIncludesNumber = (mylist: number[], number: number): boolean => {
    return mylist.includes(number);
  };

  const rowSelected = (isChecked: boolean, args: any) => {
    if (
      args.data.isChecked == 1 &&
      !isListIncludesNumber(IsContainerTaskClickedIndexList, args.rowIndex)
    ) {
      if (args.isInteracted) {
        IsContainerTaskClickedIndexList.push(args.rowIndex);
      }
      return false;
    }

    if (args.isInteracted) {
      const rowSelectData = grid.getSelectedRecords()[0];
      var theExObj = { ...args.data };
      if (rowSelectData === undefined) {
        Message.error('No record selected Container');
        isChecked = false;
        return false;
      }
      if (isChecked) {
        theExObj.container_id = rowSelectData.container_id;
        theExObj.container_name = rowSelectData.container_name;
        theExObj.status = 3;
        theExObj.isRun = false;
        theExObj.isDone = true;
        SaveListContainerTask(theExObj);
      } else {
        theExObj.container_id = rowSelectData.container_id;
        DeleteContainerTasks(theExObj);
      }
    }
  };
  return (
    <div style={{ width: '100%', height: '100%' }}>
      <div className='scrollContentSync'>
        <div className='container-sync'>
          <GlobalGrid
            id='sync-container'
            query={`org_id=${all_information.company_id}&rt=${refresh_token}`}
            columns={containerColumns}
            height={'calc(-290px + 100vh)'}
            signalOfLoad={true}
            refreshRequest={refreshGrid}
            refreshRequestHandle={() => {
              setRefreshGrid('');
            }}
            gridRef={(g: GridComponent) => (grid = g)}
            get_query={'dig/container'}
            delete_query={'dig/container/delete'}
            noNeedPagination
            rowSelected={rowselectContainer.bind(this)}
            rowDeselected={rowDeSelectContainer.bind(this)}
            toolbarOptions={toolbarOptions}
            toolbarClickItems={toolbarClick}
            avoidWhereClause
          />
        </div>
        {showDialog ? (
          <GlobalDialog
            refDialog={(ref: DialogComponent) => (dialog = ref)}
            showDialog={showDialog}
            setShowDialog={setShowDialog.bind(this)}
            header={`Container's Tasks`}
            isFullScreen={true}
            hideDoneButton={false}
          >
            <div className='container-with-task'>
              <GlobalGrid
                id='sync-container-task'
                query={c_container_id.toString()}
                columns={tasksColumns}
                height='calc(75vh)'
                signalOfLoad={true}
                gridRef={(g) => (gridTaskWitContainer = g)}
                toolbarTemplate={renderToolbarTemplate.bind(this)}
                get_query={'dig/container/task'}
                noNeedPagination
                rowSelected={rowSelected.bind(this, true)}
                rowDeselected={rowSelected.bind(this, false)}
              />
            </div>
          </GlobalDialog>
        ) : null}
      </div>
      {hideAddEditDialog ? (
        <GlobalDialog
          refDialog={(ref: DialogComponent) => (dialog = ref)}
          showDialog={hideAddEditDialog}
          setShowDialog={(val) => setHideAddEditDialog(val)}
          header={hideDialgogisAdd ? 'Add Container' : 'Edit Container'}
          isFullScreen={false}
          width={'350px'}
          height={'auto'}
          buttons={buttons}
          hideDoneButton={true}
        >
          <div className='container'>
            <div className='row '>
              <div className='col-md-12'>
                <div className='col-md-12'>
                  <TextBoxComponent
                    id='sync-container-cont-name'
                    placeholder='Container Name'
                    floatLabelType='Auto'
                    value={container_name}
                    onChange={(e: any) => {
                      container_name = e.value;
                    }}
                  />
                </div>
                {isAdd ? (
                  <div className='col-md-12'>
                    <DropDownListComponent
                      id='syncContaineradapterName'
                      placeholder='Adapter'
                      floatLabelType='Auto'
                      value={adapterValue}
                      fields={{
                        text: 'AdaptorName',
                        value: 'AdaptorID',
                      }}
                      dataSource={adapterData}
                      onChange={(el: any) => {
                        setAdapterValue(el.value);
                      }}
                    />
                  </div>
                ) : null}
                <div className='col-md-12'>
                  <TextBoxComponent
                    id='sync-container-alert-mail'
                    placeholder='Alert Email'
                    floatLabelType='Auto'
                    value={alert_mail}
                    onChange={(e: any) => {
                      alert_mail = e.value;
                    }}
                  />
                </div>
                <div className='col-md-12'>
                  <DropDownListComponent
                    id='tmSyncElement'
                    placeholder='Interval'
                    floatLabelType='Auto'
                    value={intervalValue}
                    fields={{
                      text: 'name',
                      value: 'id',
                    }}
                    dataSource={intervalData}
                    onChange={(el: any) => {
                      let theOnce = el.value === 1 ? true : false;
                      let theDaily = el.value === 2 ? true : false;
                      let theWeekly = el.value === 3 ? true : false;
                      let theHourly = el.value === 4 ? true : false;
                      let thePerMin = el.value === 5 ? true : false;
                      setIntervalValue(el.value);
                      setIsOnce(theOnce);
                      setIsDaily(theDaily);
                      setIsWeekly(theWeekly);
                      setIsHourly(theHourly);
                      setIsPerMin(thePerMin);
                    }}
                  />
                </div>
                {isDaily && !isHourly && !isPerMin ? (
                  !isDaily ? (
                    <div className='col-md-12'>
                      <DatePickerComponent
                        id='sync-container-start-date'
                        placeholder='Interval Start Date'
                        floatLabelType='Auto'
                        value={selectedDate}
                        onChange={(el: any) => {
                          selectedDateValue = el.value;
                        }}
                      />
                    </div>
                  ) : (
                    <div className='col-md-12'>
                      <DropDownListComponent
                        id='sync-container-int-start-day'
                        placeholder='Interval Start Day'
                        floatLabelType='Auto'
                        value={selectedDaysValue}
                        fields={{
                          text: 'name',
                          value: 'id',
                        }}
                        dataSource={theTheDays}
                        onChange={(el: any) => {
                          selectedDaysValue = el.value;
                        }}
                      />
                    </div>
                  )
                ) : null}
                {isHourly ? (
                  <div className='col-md-12'>
                    <TextBoxComponent
                      id='sync-container-int-min'
                      placeholder='Interval Start Min.'
                      floatLabelType='Auto'
                      type='number'
                      htmlAttributes={{ min: '5', max: '1000' }}
                      value={hourly_minute_value?.toString()}
                      onChange={(el: any) => {
                        hourly_minute_value = el.value;
                      }}
                    />
                  </div>
                ) : null}
                {isPerMin ? (
                  <div className='col-md-12'>
                    <TextBoxComponent
                      id='sync-container-per-min'
                      placeholder='Per Min.'
                      floatLabelType='Auto'
                      type='number'
                      htmlAttributes={{ min: '5', max: '1000' }}
                      value={per_minute_value?.toString()}
                      onChange={(el: any) => {
                        per_minute_value = el.value;
                      }}
                    />
                  </div>
                ) : null}
                <div className='col-md-12'>
                  <TimePickerComponent
                    id='tmsyncElementStartTime'
                    placeholder='Interval Start Time'
                    floatLabelType='Auto'
                    format={'HH:mm'}
                    value={start_time}
                    onChange={(el: any) => {
                      start_time = el.value;
                    }}
                  />
                </div>
                <div
                  className='col-md-12'
                  style={{
                    marginTop: 15,
                  }}
                >
                  <div className='col-md-7'>Enabled</div>
                  <div className='col-md-5'>
                    <SwitchComponent
                      id='swichActiveOrInActive'
                      cssClass='handle-color'
                      change={(e: any) => {
                        enabled = e.checked;
                      }}
                      checked={enabled}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </GlobalDialog>
      ) : null}
    </div>
  );
};

export default SyncContainer;
